import{ useEffect, useState } from 'react'
import { Grid, GridItem, Box } from '@chakra-ui/react'
import { Navbar, Sidebar } from '../../components'
import MyDiv from './layout.style'
import { useLocation, useNavigate } from 'react-router'
import * as routesNames from '../../constant/routes'

const AppLayout = (props: any) => {
  const [isActive, setIsActive] = useState(() => {
    return sessionStorage.getItem('activePortal') || 'infusive-media';
  });

  const [toggleSidebar, setToggleSidebar] = useState(false)
  const handleSidePanel = () => {
    setToggleSidebar(!toggleSidebar)
  }
const location = useLocation();

const isLeadDetail =
    location.pathname === routesNames.LEADDETAIL;
  useEffect(() => {
    sessionStorage.setItem('activePortal', isActive);
  }, [isActive]);

  return (
    <MyDiv>
      {/* <Grid  gap={0} className={toggleSidebar ? 'parent_grid_toggle' : 'parent_grid'}> */}
      <Grid
    gap={0}
    className={
        toggleSidebar || location.state?.fullScreen
            ? "parent_grid_toggle"
            : "parent_grid"
    }
>

        <GridItem >
          {/* <Sidebar toggleSidebar={toggleSidebar} handleSidePanel={handleSidePanel} activePortal={isActive} /> */}
          <Sidebar
    toggleSidebar={
        toggleSidebar || location.state?.fullScreen
    }
    handleSidePanel={handleSidePanel}
    activePortal={isActive}
/>
        </GridItem>

        {/* <GridItem className={toggleSidebar ? 'children_grid_toggle' : 'children_grid'}> */}
        <GridItem
  className={
    toggleSidebar || location.state?.fullScreen
      ? "children_grid_toggle"
      : "children_grid"
  }
>
          <Navbar />
          <Box mt={4} className='inner-children'>
            {props.children}
          </Box>
        </GridItem>

      </Grid>
    </MyDiv>

  )
}

export default AppLayout
